import { Counter } from '../../../../Counter'
import Text from '../../../../Text'

import * as styles from '../RequestProfileTabEmailsSubTabs.module.css'

function RequestProfileTabEmailsSubTabsValueItem({ className, value }) {
  const { count, label, unreadCount } = value

  const hasCount = Number.isFinite(count)

  return (
    <div className={className}>
      <span className={styles.labelGroup}>
        <Text isSecondary className={styles.label}>
          {label}
        </Text>
        {hasCount ? (
          <Text isSecondary className={styles.count}>
            {`(${count})`}
          </Text>
        ) : null}
      </span>
      <Counter className={styles.unreadCounter} count={unreadCount} />
    </div>
  )
}

export default RequestProfileTabEmailsSubTabsValueItem
